import {isSupported} from "./unsupported";
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import {LMap, LTileLayer, LMarker, LPopup, LTooltip} from 'vue2-leaflet';
import {Icon} from 'leaflet';
import 'leaflet/dist/leaflet.css';
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@fortawesome/fontawesome-free/css/all.min.css'
import axios from 'axios';
import VueAxios from 'vue-axios';
import BootstrapVue from 'bootstrap-vue';
import VueAnalytics from 'vue-analytics'
import './registerServiceWorker';
import Fab from 'material-components-vue/dist/fab';

let supportedBrowser = isSupported(function () {
    window.location.href = "unsupported.html";
}, false);

if (supportedBrowser) {
    Vue.use(Fab);

    Vue.use(VueAxios, axios);
    Vue.use(BootstrapVue);

    Vue.use(VueAnalytics, {
        id: 'UA-9499436-17',
        disabled: true
    });

    Vue.component('l-map', LMap);
    Vue.component('l-tile-layer', LTileLayer);
    Vue.component('l-marker', LMarker);
    Vue.component('l-popup', LPopup);
    Vue.component('l-tooltip', LTooltip);

    delete Icon.Default.prototype._getIconUrl;

    Icon.Default.mergeOptions({
        iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
        iconUrl: require('leaflet/dist/images/marker-icon.png'),
        shadowUrl: require('leaflet/dist/images/marker-shadow.png')
    });

    Vue.config.productionTip = false;

    new Vue({
        router,
        store,
        render: function (h) {
            return h(App)
        }
    }).$mount('#app');
}
